'use strict';

var __makeTemplateObject =
  (void 0 && (void 0).__makeTemplateObject) ||
  function (cooked, raw) {
    if (Object.defineProperty) {
      Object.defineProperty(cooked, 'raw', {
        value: raw,
      });
    } else {
      cooked.raw = raw;
    }

    return cooked;
  };

var __createBinding =
  (void 0 && (void 0).__createBinding) ||
  (Object.create
    ? function (o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        Object.defineProperty(o, k2, {
          enumerable: true,
          get: function get() {
            return m[k];
          },
        });
      }
    : function (o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        o[k2] = m[k];
      });

var __setModuleDefault =
  (void 0 && (void 0).__setModuleDefault) ||
  (Object.create
    ? function (o, v) {
        Object.defineProperty(o, 'default', {
          enumerable: true,
          value: v,
        });
      }
    : function (o, v) {
        o['default'] = v;
      });

var __importStar =
  (void 0 && (void 0).__importStar) ||
  function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null)
      for (var k in mod) {
        if (k !== 'default' && Object.prototype.hasOwnProperty.call(mod, k))
          __createBinding(result, mod, k);
      }

    __setModuleDefault(result, mod);

    return result;
  };

Object.defineProperty(exports, '__esModule', {
  value: true,
});

exports.StyledCheckbox = exports.StyledCheckmark = void 0;

var styled_components_1 = __importStar(require('styled-components'));

var components_1 = require('../../../constants/components');

var generateShape = function generateShape(_a) {
  var shape = _a.shape;

  switch (shape) {
    case components_1.SHAPES.geometric:
      return styled_components_1.css(
        templateObject_1 ||
          (templateObject_1 = __makeTemplateObject(
            ['\n        border-radius: 0px;\n      '],
            ['\n        border-radius: 0px;\n      ']
          ))
      );

    case components_1.SHAPES.rounded:
      return styled_components_1.css(
        templateObject_2 ||
          (templateObject_2 = __makeTemplateObject(
            ['\n        border-radius: 3px;\n      '],
            ['\n        border-radius: 3px;\n      ']
          ))
      );

    case components_1.SHAPES.circular:
      return styled_components_1.css(
        templateObject_3 ||
          (templateObject_3 = __makeTemplateObject(
            ['\n        border-radius: 5px;\n      '],
            ['\n        border-radius: 5px;\n      ']
          ))
      );

    default:
      return '';
  }
};

var generateIconColor = function generateIconColor(_a) {
  var theme = _a.theme,
    view = _a.view,
    disabled = _a.disabled;
  var baseSvgStyles = styled_components_1.css(
    templateObject_4 ||
      (templateObject_4 = __makeTemplateObject(
        ['\n    flex-shrink: 0;\n  '],
        ['\n    flex-shrink: 0;\n  ']
      ))
  );

  if (disabled) {
    return styled_components_1.css(
      templateObject_5 ||
        (templateObject_5 = __makeTemplateObject(
          ['\n      svg {\n        fill: ', ';\n        ', ';\n      }\n    '],
          ['\n      svg {\n        fill: ', ';\n        ', ';\n      }\n    ']
        )),
      theme.transparent[25],
      baseSvgStyles
    );
  }

  switch (view) {
    case components_1.CHECKBOX_VIEW.default:
      return styled_components_1.css(
        templateObject_6 ||
          (templateObject_6 = __makeTemplateObject(
            ['\n        svg {\n          fill: ', ';\n          ', ';\n        }\n      '],
            ['\n        svg {\n          fill: ', ';\n          ', ';\n        }\n      ']
          )),
        theme.input.checkmark,
        baseSvgStyles
      );

    case components_1.CHECKBOX_VIEW.accent:
      return styled_components_1.css(
        templateObject_7 ||
          (templateObject_7 = __makeTemplateObject(
            ['\n        svg {\n          fill: ', ';\n          ', ';\n        }\n      '],
            ['\n        svg {\n          fill: ', ';\n          ', ';\n        }\n      ']
          )),
        theme.greyScale.white,
        baseSvgStyles
      );

    default:
      return '';
  }
};

var generateDisabledCheckmark = function generateDisabledCheckmark(_a) {
  var disabled = _a.disabled,
    theme = _a.theme,
    checked = _a.checked,
    indeterminate = _a.indeterminate,
    view = _a.view,
    color = _a.color;
  var baseStyles = styled_components_1.css(
    templateObject_8 ||
      (templateObject_8 = __makeTemplateObject(
        ['\n    border: 1px solid ', ';\n  '],
        ['\n    border: 1px solid ', ';\n  ']
      )),
    theme.transparent[25]
  );

  if (disabled) {
    return styled_components_1.css(
      templateObject_9 ||
        (templateObject_9 = __makeTemplateObject(
          ['\n      background-color: ', ';\n    '],
          ['\n      background-color: ', ';\n    ']
        )),
      theme.transparent[10]
    );
  }

  if (checked || indeterminate) {
    switch (view) {
      case components_1.CHECKBOX_VIEW.default:
        return styled_components_1.css(
          templateObject_10 ||
            (templateObject_10 = __makeTemplateObject(
              ['\n          ', ';\n        '],
              ['\n          ', ';\n        ']
            )),
          baseStyles
        );

      case components_1.CHECKBOX_VIEW.accent:
        return styled_components_1.css(
          templateObject_11 ||
            (templateObject_11 = __makeTemplateObject(
              ['\n          background-color: ', ';\n          border: none;\n        '],
              ['\n          background-color: ', ';\n          border: none;\n        ']
            )),
          color
        );

      default:
        return '';
    }
  }

  return styled_components_1.css(
    templateObject_12 ||
      (templateObject_12 = __makeTemplateObject(['\n    ', ';\n  '], ['\n    ', ';\n  '])),
    baseStyles
  );
};

var generateDisabledLabel = function generateDisabledLabel(_a) {
  var disabled = _a.disabled;

  if (disabled) {
    return styled_components_1.css(
      templateObject_13 ||
        (templateObject_13 = __makeTemplateObject(
          ['\n      cursor: not-allowed;\n    '],
          ['\n      cursor: not-allowed;\n    ']
        ))
    );
  }

  return styled_components_1.css(
    templateObject_14 ||
      (templateObject_14 = __makeTemplateObject(
        ['\n    cursor: pointer;\n  '],
        ['\n    cursor: pointer;\n  ']
      ))
  );
};

var generateCheckedCheckmark = function generateCheckedCheckmark(_a) {
  var checked = _a.checked,
    indeterminate = _a.indeterminate,
    color = _a.color,
    view = _a.view;

  if (checked || indeterminate) {
    switch (view) {
      case components_1.CHECKBOX_VIEW.default:
        return styled_components_1.css(
          templateObject_15 ||
            (templateObject_15 = __makeTemplateObject(
              ['\n          border-color: ', ';\n        '],
              ['\n          border-color: ', ';\n        ']
            )),
          color
        );

      default:
        return '';
    }
  }

  return '';
};

var generateSize = function generateSize(_a) {
  var size = _a.size;

  switch (size) {
    case components_1.CHECKBOX_SIZES.small:
      return styled_components_1.css(
        templateObject_16 ||
          (templateObject_16 = __makeTemplateObject(
            ['\n        width: 16px;\n        height: 16px;\n      '],
            ['\n        width: 16px;\n        height: 16px;\n      ']
          ))
      );

    case components_1.CHECKBOX_SIZES.medium:
      return styled_components_1.css(
        templateObject_17 ||
          (templateObject_17 = __makeTemplateObject(
            ['\n        width: 20px;\n        height: 20px;\n      '],
            ['\n        width: 20px;\n        height: 20px;\n      ']
          ))
      );

    default:
      return '';
  }
};

var generateFocus = function generateFocus(_a) {
  var view = _a.view,
    theme = _a.theme;

  switch (view) {
    case components_1.CHECKBOX_VIEW.accent:
      return styled_components_1.css(
        templateObject_18 ||
          (templateObject_18 = __makeTemplateObject(
            ['\n        border: 1px solid ', ';\n      '],
            ['\n        border: 1px solid ', ';\n      ']
          )),
        theme.transparent[25]
      );

    default:
      return '';
  }
};

exports.StyledCheckmark = styled_components_1.default.span(
  templateObject_19 ||
    (templateObject_19 = __makeTemplateObject(
      [
        '\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  position: absolute;\n  top: 2px;\n  left: 2px;\n\n  ',
        ';\n  ',
        ';\n  ',
        ';\n  ',
        ';\n',
      ],
      [
        '\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  position: absolute;\n  top: 2px;\n  left: 2px;\n\n  ',
        ';\n  ',
        ';\n  ',
        ';\n  ',
        ';\n',
      ]
    )),
  generateSize,
  generateShape,
  generateDisabledCheckmark,
  generateIconColor
);
exports.StyledCheckbox = styled_components_1.default.label(
  templateObject_20 ||
    (templateObject_20 = __makeTemplateObject(
      [
        '\n  -webkit-tap-highlight-color: transparent;\n\n  display: inline-flex;\n  align-items: center;\n  position: relative;\n  outline: none;\n  min-height: ',
        ';\n  padding-left: ',
        ';\n\n  ',
        ';\n\n  > input {\n    position: absolute;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    opacity: 0;\n\n    &:enabled + ',
        ' {\n      ',
        ';\n    }\n\n    &:focus:enabled + ',
        ' {\n      ',
        ';\n      border-width: 2px;\n    }\n  }\n\n  @media not all and (hover: none) {\n    &:hover {\n      > input:enabled + ',
        ' {\n        border-color: ',
        ';\n      }\n    }\n  }\n',
      ],
      [
        '\n  -webkit-tap-highlight-color: transparent;\n\n  display: inline-flex;\n  align-items: center;\n  position: relative;\n  outline: none;\n  min-height: ',
        ';\n  padding-left: ',
        ';\n\n  ',
        ';\n\n  > input {\n    position: absolute;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    opacity: 0;\n\n    &:enabled + ',
        ' {\n      ',
        ';\n    }\n\n    &:focus:enabled + ',
        ' {\n      ',
        ';\n      border-width: 2px;\n    }\n  }\n\n  @media not all and (hover: none) {\n    &:hover {\n      > input:enabled + ',
        ' {\n        border-color: ',
        ';\n      }\n    }\n  }\n',
      ]
    )),
  function (_a) {
    var size = _a.size;
    return size === components_1.CHECKBOX_SIZES.medium ? '24px' : '20px';
  },
  function (_a) {
    var size = _a.size;
    return size === components_1.CHECKBOX_SIZES.medium ? '32px' : '28px';
  },
  generateDisabledLabel,
  exports.StyledCheckmark,
  generateCheckedCheckmark,
  exports.StyledCheckmark,
  generateFocus,
  exports.StyledCheckmark,
  function (_a) {
    var color = _a.color;
    return color;
  }
);
var templateObject_1,
  templateObject_2,
  templateObject_3,
  templateObject_4,
  templateObject_5,
  templateObject_6,
  templateObject_7,
  templateObject_8,
  templateObject_9,
  templateObject_10,
  templateObject_11,
  templateObject_12,
  templateObject_13,
  templateObject_14,
  templateObject_15,
  templateObject_16,
  templateObject_17,
  templateObject_18,
  templateObject_19,
  templateObject_20;
